import * as types from "../constants/grievance_constants";

const initialState = {
  grievances: [],
  currentGrievance: null,
  grievanceError: null,
  message: null,
  uploadMessage: null,
};

const grievanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_USER_GRIEVANCES_SUCCESS:
      return {
        ...state,
        grievances: payload?.grievances || [],
        grievanceError: null,
      };

    case types.GET_SINGLE_GRIEVANCE_SUCCESS:
      return {
        ...state,
        currentGrievance: payload?.grievance || null,
        grievanceError: null,
      };

    case types.CREATE_GRIEVANCE_SUCCESS:
      return {
        ...state,
        currentGrievance: payload?.grievance || null,
        message: payload?.message || null,
        grievanceError: null,
      };

    case types.UPLOAD_GRIEVANCE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        currentGrievance: payload?.grievance || state.currentGrievance,
        uploadMessage: payload?.message || null,
        grievanceError: null,
      };

    case types.GET_USER_GRIEVANCES_FAILURE:
    case types.GET_SINGLE_GRIEVANCE_FAILURE:
    case types.CREATE_GRIEVANCE_FAILURE:
    case types.UPLOAD_GRIEVANCE_ATTACHMENT_FAILURE:
      return {
        ...state,
        grievanceError: payload || null,
      };

    default:
      return state;
  }
};

export default grievanceReducer;
